import { Recycle } from "lucide-react";
import { useTranslation } from "react-i18next";
import HarvestThresholdsCard from "@/components/admin/HarvestThresholdsCard";
import GradePricingSection from "@/components/admin/GradePricingSection";
import HarvestingManagement from "@/pages/admin/HarvestingManagement";
import { useSectionHashScroll } from "@/components/settings/useSectionHashScroll";

export default function PartsHarvestingSettings() {
  const { t } = useTranslation("settings");
  useSectionHashScroll();

  return (
    <div className="min-h-screen bg-background pb-24">
      <div className="px-6 pt-8 pb-6">
        <div className="flex items-center gap-2 mb-1">
          <Recycle className="w-5 h-5 text-primary" />
          <h1 className="text-2xl font-bold text-foreground">{t("nav.partsHarvesting")}</h1>
        </div>
        <p className="text-muted-foreground">
          Thresholds, grade pricing, harvestable components and which components to harvest per brand.
        </p>
      </div>
      <div className="px-6 space-y-8">
        <div id="harvest-thresholds">
          <HarvestThresholdsCard />
        </div>
        <GradePricingSection />
        <HarvestingManagement embedded />
      </div>
    </div>
  );
}
